import React from 'react';
import PropTypes from 'prop-types';
import EditInterviewModal from '../../EditInterviewModal';
import ConfirmableLink from '../../ConfirmableLink';
import './InterviewActions.scss';

class InterviewActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showCancellationCopy: false,
    };
  }

  render() {
    const { showCancellationCopy } = this.state;
    const {
      interview,
      interviewType,
      editInterviewPath,
      csrfToken,
      possibleInterviewers,
      invitableRoles,
      canEdit,
      canCancel,
      location,
      editModalRef,
      resheduleModalRef,
      onCancel,
      repOrOwner,
      newInterviewSlot,
      availableInterviewSlotUrl,
    } = this.props;

    return (
      <div
        className="style-guide pending-interview-actions-container body-text-2 medium-weight muted-gray-text d-flex flex-column flex-md-row gap-3 justify-content-between"
      >
        { }
        {showCancellationCopy ? (
          <div className="normal-weight">Do you want to cancel this call?</div>
        ) : (
          repOrOwner && interviewType === 'upcoming' ? (
            <EditInterviewModal
              editInterviewPath={editInterviewPath}
              csrfToken={csrfToken}
              possibleInterviewers={possibleInterviewers}
              invitableRoles={invitableRoles}
              interview={interview}
              resheduleModalRef={resheduleModalRef}
              location={location}
              interviewType={interviewType}
              newInterviewSlot={newInterviewSlot}
              availableInterviewSlotUrl={availableInterviewSlotUrl}
              interviewReschedule
            />
          ) : (
            <div className="normal-weight">Need to modify?</div>
          )
        )}
        <div className="d-flex flex-column flex-md-row gap-3">
          { (!showCancellationCopy && canEdit)
            && (
            <EditInterviewModal
              editInterviewPath={editInterviewPath}
              csrfToken={csrfToken}
              possibleInterviewers={possibleInterviewers}
              invitableRoles={invitableRoles}
              interview={interview}
              editModalRef={editModalRef}
              location={location}
              interviewType={interviewType}
              disableAvailabilitySelection={interviewType === 'upcoming'}
              newInterviewSlot={newInterviewSlot}
              availableInterviewSlotUrl={availableInterviewSlotUrl}
            />
            )}
          { canCancel
          && (
          <ConfirmableLink
            spaceBetween="10px"
            linkClassName="medium-weight body-text-2 warning-text"
            triggerCTA="Cancel"
            confirmCTA="Yes"
            cancelCTA="No"
            showCopy={false}
            onSubmit={onCancel}
            onClickTrigger={() => this.setState({ showCancellationCopy: true })}
            onClickCancel={() => this.setState({ showCancellationCopy: false })}
          />
          )}
        </div>
      </div>
    );
  }
}

InterviewActions.propTypes = {
  editInterviewPath: PropTypes.string.isRequired,
  canCancel: PropTypes.bool,
  canEdit: PropTypes.bool,
  possibleInterviewers: PropTypes.shape({
    current_user_permission: PropTypes.shape({}),
    team_members: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  interview: PropTypes.shape({}).isRequired,
  csrfToken: PropTypes.string.isRequired,
  location: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  editModalRef: PropTypes.func,
  resheduleModalRef: PropTypes.func,
  interviewType: PropTypes.string.isRequired,
  repOrOwner: PropTypes.bool,
  newInterviewSlot: PropTypes.bool,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
};

InterviewActions.defaultProps = {
  location: 'Location Unspecified',
  canCancel: false,
  canEdit: false,
  editModalRef: () => null,
  resheduleModalRef: () => null,
  repOrOwner: false,
  newInterviewSlot: false,
};

export default InterviewActions;
